
export default function Dash() {
    return (
        <>
            App
        </>
    )
}